import { Node, Edge } from "reactflow";
import { processNodesBeforeSave } from "./processNodesBeforeSave";
import { processEdgesBeforeSave } from "./processEdgesBeforeSave";

function transformNodes(nodes: Node[]) {
  return nodes.map((node) => {
    const updatedData = { ...node.data };

    if (updatedData.zapId) {
      updatedData.zapId = `\${{ zaps.${updatedData.zapId} }}`;
    }

    if (updatedData.tableId) {
      updatedData.tableId = `\${{ tables.${updatedData.tableId} }}`;
    }

    if (updatedData.chatbotId) {
      updatedData.chatbotId = `\${{ chatbots.${updatedData.chatbotId} }}`;
    }

    if (updatedData.projectId && updatedData.pageId) {
      updatedData.pageId = `\${{ interfaces.${updatedData.projectId}.${updatedData.pageId} }}`;
      updatedData.projectId = `\${{ interfaces.${updatedData.projectId} }}`;
    } else if (updatedData.projectId) {
      updatedData.projectId = `\${{ interfaces.${updatedData.projectId} }}`;
    }

    return {
      ...node,
      data: {
        ...updatedData,
        attributionSourceType: "AI_SYSTEMS",
      },
    };
  });
}

type Params = {
  nodes: Node[];
  edges: Edge[];
};

export function convertAssetIdsToPlaceholderIds({ nodes, edges }: Params) {
  return {
    nodes: processNodesBeforeSave(transformNodes(nodes)),
    edges: processEdgesBeforeSave(edges),
  };
}
